import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MasterPage from '../layouts/master-page';
import MasterPageAuth from '../layouts/master-page-auth';
import { authRoutes, publicRoutes } from './route-name';
import { AuthProtected, AccessRoute, AccessTokenExpire } from './route-auth';

const RouteIndex = () => {
    const publicRoutesPaths = publicRoutes.map((r) => r.path);
    const authRoutesPaths = authRoutes.map((r) => r.path);
    return(
        <React.Fragment>
            <Switch>
                <Route path={publicRoutesPaths}>
                    <MasterPageAuth>
                        <Switch>
                            {publicRoutes.map((route, idx) => (
                                <Route key={idx}
                                    path={route.path}
                                    component={route.component}
                                    exact={true}
                                />
                            ))}
                        </Switch>
                    </MasterPageAuth>
                </Route>
                <Route path={authRoutesPaths}>
                    <AuthProtected>
                        <MasterPage>
                            <Switch>
                                {authRoutes.map((route, idx) => (
                                    <AccessRoute key={idx} 
                                        path={route.path}
                                        component={route.component}
                                        exact={true}   
                                    />
                                ))}
                            </Switch>
                        </MasterPage>
                    </AuthProtected>
                </Route>
            </Switch>
        </React.Fragment>
    );
};

export default RouteIndex;